import { render } from "./backstretch.html?vue&type=template&id=66420bd5&scoped=true&ts=true"
import script from "./backstretch.ts?vue&type=script&lang=ts"
export * from "./backstretch.ts?vue&type=script&lang=ts"

import "./backstretch.scss?vue&type=style&index=0&id=66420bd5&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66420bd5"]])

export default __exports__